import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["selected", "unselected"]

  toggle(event) {
    const card = event.currentTarget.closest("[data-program-id]")

    if (card.dataset.selected === "true") {
      this.deselect(card)
    } else {
      this.select(card)
    }
  }

  select(card) {
    const button = card.querySelector("button")
    const activeField = card.querySelector("input[name$='[active]']")

    card.dataset.selected = "true"
    activeField.value = "true"
    button.textContent = "Added"
    button.classList.remove(...this.unselectedClasses)
    button.classList.add(...this.selectedClasses)
  }

  deselect(card) {
    const button = card.querySelector("button")
    const activeField = card.querySelector("input[name$='[active]']")

    card.dataset.selected = "false"
    activeField.value = "false"
    button.textContent = "Add"
    button.classList.remove(...this.selectedClasses)
    button.classList.add(...this.unselectedClasses)
  }
}
